/**
 * #1102 I7 — after a person changes their OWN role, may they still sync member access (the dialog's actions need
 * `manage_member:write`)? Asked of the server after the change — never guessed from the new role name: an Admin whose
 * `manage_member` was removed can't, a Member granted it can. A failed read answers no (the dialog's calls would only
 * be refused).
 */
export async function keepsMemberManagement(
  tenantId: string,
  request: <T>(path: string) => Promise<T>,
): Promise<boolean> {
  try {
    const r = await request<{ capabilities?: Record<string, unknown> }>(`/api/orgs/${tenantId}/my-capabilities`)
    return r.capabilities?.manage_member === 'write'
  } catch {
    return false
  }
}
